import { render, staticRenderFns } from "./EnterTerminationReviewObject.vue?vue&type=template&id=480ecee2&scoped=true"
import script from "./EnterTerminationReviewObject.vue?vue&type=script&lang=js"
export * from "./EnterTerminationReviewObject.vue?vue&type=script&lang=js"
import style0 from "./EnterTerminationReviewObject.vue?vue&type=style&index=0&id=480ecee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ecee2",
  null
  
)

export default component.exports